var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-no-data"},[_c('img',{attrs:{"src":require("../assets/images/no_data.png")}}),_c('div',{staticClass:"name"},[_vm._v("暂无"+_vm._s(_vm.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }